export const data = [
    {
        id: "0",
        question: "What is an advantage of using a Belt?",
        answer: "Much lighter.",
        variants: [`Comes in several colors.`, `Much lighter.`, `Much more durable.`, `Most reliable.`]
    },
    {
        id: "1",
        question: "What is an advantage of using Gears?",
        answer: "Most reliable and efficient.",
        variants: [`Heavy.`, `Cheaper.`, `Most reliable and efficient.`, `Big size footprint.`]
    },
    {
        id: "2",
        question: "What is an advantage of Chains?",
        answer: "",
        variants: [`Can be easy to tension.`, `Most efficient out of all of the power transfer methods`, `Can transfer rotational energy over a longer distance under high-load applications.`, `No greasing needed.`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },